<template>
    <div class="page-about">
        <SupportList />
        <!--banner-->
        <div class="banner">
            <div class="container">
                <h2 class="timeline">关于我们</h2>
            </div>
        </div>
        <!--start-about-->
        <div class="about">
            <div class="container">
                <div class="about-bottom">
                    <p>{{settingList.about_text1}}</p>
                    <p>{{settingList.about_text2}}</p>
                    <p>{{settingList.about_text3}}</p>
                    <p>{{settingList.about_text4}}</p>
                    <p>{{settingList.about_text5}}</p>
                    <p>{{settingList.about_text6}}</p>
                    <p><a href="javascript:void(0)"  class="dashang" title="如果您喜欢我们的游戏，欢迎支持一下我们" @click="open()">赞助支持</a></p>
                    <p><router-link to="/support" target="_blank" style="color:gray;text-decoration: underline;">查看赞助支持者列表</router-link>
                    </p>
                    <!--<div class="about-btm">-->
                        <!--<div class="col-md-6 about-left">-->
                            <!--<a href="article/cat.html"><img class="img-responsive" src="images/game/cat/face.jpg" alt="" /></a>-->
                        <!--</div>-->
                        <!--<div class="col-md-6 about-right">-->
                            <!--<a href="article/cuipi.html"><img class="img-responsive" src="images/game/cuipi/face.jpg" alt="" /></a>-->
                        <!--</div>-->
                        <!--<div class="clearfix"></div>-->
                    <!--</div>-->
                </div>

                <!--team-->
                <div class="team-us">
                    <div class="team-top ">
                        <br><br>
                        <h3>加入我们</h3>
                        <p>· 排名不分先后 ·</p>
                    </div>
                    <div class="team-bottom">
                        <ul class="ch-grid">
                            <li v-for="(user,index) in userList" :key="index">
                                <a :href="'/#/s='+user.name" :title="'点击查看 @' + user.name + ' 投稿 / 汉化的所有游戏'" target="_blank">
                                <div class="ch-item" :style="'background: url(static/images/about/team-'+user.order+'.jpg);background-position:center;'">
                                    <div class="ch-info-wrap">
                                        <div class="ch-info" :title="user.desc">
                                            <div class="ch-info-front" :style="'background: url(static/images/about/team-'+user.order+'.jpg);backface-visibility:hidden;background-position:center;'"></div>
                                            <div class="ch-info-back">
                                                <h3>{{user.name}}</h3>
                                                <div class="link-tips">点击查看Ta参与的游戏</div>
                                                <p>{{user.title}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </a>
                            </li><li>
                                <div class="ch-item ch-img-99">
                                    <div class="ch-info-wrap">
                                        <div class="ch-info">
                                            <div class="ch-info-front ch-img-99"></div>
                                            <div class="ch-info-back">
                                                <h3>虚位以待</h3>
                                                <p>就等你来</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!--//team-->
        <!--//about-->
        <!--联系方式-->
        <div class="contact">
            <div class="container">
                <h3>联系方式</h3>
                <div class="address">
                    <div class=" address-more">
                        <div class="col-md-4 address-grid " v-for="(item, index) in activeContactList" :key="index">
                            <i :class='"glyphicon " + item.icon'></i>
                            <div class="address1">
                                <p>{{item.title}}</p>
                                <p v-if="item.link"><a :href="item.link" target="_blank" :title="item.tip">{{item.button}}</a></p>
                                <p v-if="!item.link"><a :title="item.tip">{{item.button}}</a></p>
                            </div>
                            <div class="clearfix"> </div>
                        </div>
                    </div>
                </div>

                <div class="clearfix"> </div>

            </div>
        </div>
        <!--联系方式-->
    </div>
</template>

<script>
import SupportList from '@/components/Support.vue'
export default {
  name: 'Demo',
  components: { SupportList },
  data() {
    return {
      userList: [],
      contactList: [],
      settingList: []
    }
  },
  computed: {
    activeContactList() {
      return this.contactList.filter(item => item.status === 1)
    }
  },
  created() {
    this.getData()
    this.getAboutSetting()
    this.getContact()
  },
  mounted() {},
  methods: {
    getData() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/user.json' + '?' + timeStamp).then(res => {
        if (res.data) {
          var data = []
          res.data.forEach(el => {
            if (el.status !== 0) {
              data.push(el)
            }
          })
          this.userList = data
        }
      },
      res => {
        console.log('error')
      }
      )
    },
    open() {
      $('.hide_box').fadeIn()
      $('.shang_box').fadeIn()
    },
    getAboutSetting() {
      if (localStorage.getItem('settingList')) {
        this.settingList = JSON.parse(localStorage.getItem('settingList'))[0]
      } else {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/setting.json' + '?' + timeStamp).then(res => {
        this.settingList = res.data[0]
      },
      res => {
        console.log('error')
      }
      )
      }
    },
    getContact() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/contact.json' + '?' + timeStamp).then(res => {
        this.contactList = res.data
      },
      res => {
        console.log('error')
      }
      )
    },
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
